import React, { FC } from "react";
import "./CVPage.style.css";

export const CVPage: FC = () => {
  return (
    <div className="cvpage-content">
      <h1>All the skills</h1>
      <p>
        As a professional working in IT since 2002, my skills have grown and
        evolved to keep in line with market requirements as well as supporting
        those who haven't been able to commit so much in their IT solutions.
      </p>
      <p>
        Numerous professional qualifications and years of hands-on experience as
        well as experience in leading and mentoring teams.
      </p>
      <p>
        My main areas of expertise are in C# and Java, the Microsoft tech stack,
        many database technologies both SQL and NoSQL based, as well as Azure
        and AWS cloud platforms.
      </p>
      <p>
        If you'd like to know more or want to discuss how I could help you, I'd
        be happy to have a chat. Drop me a message below and I'll get back to
        you as soon as possible.
      </p>
    </div>
  );
};

export default CVPage;
